/*
 * File: SearchResults.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description:  Displays search results
 */
import React from "react";
import { observer, PropTypes as mobxProbTypes } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import UINotFound from "components/ui/UINotFound";
import SearchResultStyles from "../styles/SearchResults";
import PropTypes from "prop-types";

const SearchResults = ({ patients, parentCallBack, hasSearched }) => {
  if (hasSearched && patients.length === 0) {
    return <UINotFound message="No patients were found" />;
  }

  const listItems = patients.map(p => {
    let title = p.firstName + " " + p.lastName + " (" + p.displayId + ")";
    let onClick = parentCallBack.bind(this, p);

    return (
      <ListItem key={p.patientId} onClick={onClick}>
        <ListItemText primary={title} />
      </ListItem>
    );
  });

  return <List className="navList">{listItems}</List>;
};

SearchResults.propTypes = {
  patients: PropTypes.oneOfType([
    mobxProbTypes.observableArray,
    PropTypes.array
  ]).isRequired,
  parentCallBack: PropTypes.func.isRequired,
  hasSearched: PropTypes.bool.isRequired
};

export default withStyles(SearchResultStyles)(observer(SearchResults));
